import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SizeTable } from '../table';

const bibOverallTableData = {
  headers: [
    [
      {
        content: "Men's Bib Overall",
        colSpan: 3,
      },
    ],
    [
      {
        content: 'Wader Size',
      },
      {
        content: 'Waist(In)',
      },
      {
        content: 'Hip(In)',
      },
    ],
  ],
  data: [
    [
      {
        content: '28',
      },
      {
        content: '28',
      },
      {
        content: '34',
      },
    ],
    [
      {
        content: '30',
      },
      {
        content: '30',
      },
      {
        content: '36',
      },
    ],
    [
      {
        content: '32',
      },
      {
        content: '32',
      },
      {
        content: '38',
      },
    ],
    [
      {
        content: '34',
      },
      {
        content: '34',
      },
      {
        content: '40',
      },
    ],
    [
      {
        content: '36',
      },
      {
        content: '36',
      },
      {
        content: '42',
      },
    ],
    [
      {
        content: '38',
      },
      {
        content: '38',
      },
      {
        content: '44',
      },
    ],
    [
      {
        content: '40',
      },
      {
        content: '40',
      },
      {
        content: '46',
      },
    ],
    [
      {
        content: '42',
      },
      {
        content: '42',
      },
      {
        content: '48',
      },
    ],
    [
      {
        content: '44',
      },
      {
        content: '44',
      },
      {
        content: '50',
      },
    ],
    [
      {
        content: '46',
      },
      {
        content: '46',
      },
      {
        content: '52',
      },
    ],
    [
      {
        content: '48',
      },
      {
        content: '48',
      },
      {
        content: '54',
      },
    ],
    [
      {
        content: '50',
      },
      {
        content: '50',
      },
      {
        content: '56',
      },
    ],
    [
      {
        content: '52',
      },
      {
        content: '52',
      },
      {
        content: '58',
      },
    ],
  ],
};

export const BibOverall = ({ className = 'border-b-1 border-[#E0E0E0]  w-full' }: { className?: string }) => {
  return (
    <Accordion
      type='single'
      collapsible
      className={className}
    >
      <AccordionItem
        value='item-1'
        className='border-transparent'
      >
        <AccordionTrigger className='py-[20px] font-roboto-regular text-[18px] leading-[30px]'>
          Bib Overall
        </AccordionTrigger>
        <AccordionContent className='pb-[40px] pt-0'>
          <SizeTable
            headers={bibOverallTableData.headers}
            data={bibOverallTableData.data}
          />
          <SizeTable
            headers={[
              [
                {
                  content: 'Inseam Size',
                },
                {
                  content: 'Inseam Length(In)',
                },
              ],
            ]}
            data={[
              [
                {
                  content: '28',
                },
                {
                  content: '28',
                },
              ],
              [
                {
                  content: '30',
                },
                {
                  content: '30',
                },
              ],
              [
                {
                  content: '32',
                },
                {
                  content: '32',
                },
              ],
              [
                {
                  content: '34',
                },
                {
                  content: '34',
                },
              ],
            ]}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
